import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import { CSSTransition, TransitionGroup } from 'react-transition-group'

import RentalPlan from '../helpers/rental_plan'
import SalePlan from '../helpers/sale_plan'
import Item from './item'

import styles from '../../assets/stylesheets/pages/cart/items.module.scss'

class Items extends Component {
  constructor(props) {
    super(props)
    this.state = {
      items: null
    }
    this.updateQuantity = this.updateQuantity.bind(this)
    this.updateWaiver = this.updateWaiver.bind(this)
    this.removeItem = this.removeItem.bind(this)
    this.onInputFocus = this.onInputFocus.bind(this)
    this.onInputBlur = this.onInputBlur.bind(this)
  }
  
  getItems() {
    if(this.state.items !== null) {
      return Object.values(this.state.items)
    }
    return Object.values(this.props.cartPlan.cartObject)
  }

  removeItem = id => (event) => {
    // don't submit the form with this button
    event.preventDefault()
    
    // use the stateful items if they exist, otherwise use the server cart
    const newItems = this.state.items || this.props.cartPlan.cartObject
    newItems[id].quantity = 0
    this.props.updateCartPlan(this.props.cartPlan.withItemsUpdated(newItems))
  }

  onInputFocus = () => this.setState({ items: this.props.cartPlan.cartObject })

  onInputBlur = id => event => {
    this.props.updateCartPlan(this.props.cartPlan.withItemsUpdated(this.state.items))

    // cleanup state
    this.setState({ items: null })
  }

  updateQuantity = id => event => {
    const newQuantity = event.target.value
    const item = this.state.items[id].withQuantityUpdated(newQuantity)
    this.setState({ items: { ...this.state.items, [id]: item } })
  }

  updateWaiver = id => event => {
    const protection = event.target.value
    const item = this.props.cartPlan.cartObject[id].withProtectionUpdated(protection)
    const newItems = { ...this.props.cartPlan.cartObject, [id]: item}
    this.props.updateCartPlan(this.props.cartPlan.withItemsUpdated(newItems))
  }

  updateWarranty = id => event => {
    const item = this.props.cartPlan.cartObject[id].withWarrantyUpdated(event.target.checked)
    const newItems = { ...this.props.cartPlan.cartObject, [id]: item}
    this.props.updateCartPlan(this.props.cartPlan.withItemsUpdated(newItems))
  }

  render() {
    const {
      toggleLenscapModal,
      cartPlan: {}
    } = this.props

    if(Object.values(this.props.cartPlan.cartObject).length) {
      return (
        <TransitionGroup component='ul' className={cx('items', 'cart-items', styles['cart-items'])}>
          {this.getItems().map(item => (
            <CSSTransition
              unmountOnExit
              key={item.id}
              timeout={300} // way too much time, actual transition is handled in css
              classNames={{
                exit: styles['item__wrapper--exit'],
                exitActive: styles['item__wrapper--exit-active'],
                exitDone: styles['item__wrapper--exit-done'],
               }}
            >
              <Item
                type={this.props.cartPlan.type}
                item={item}
                toggleLenscapModal={toggleLenscapModal}
                updateWaiver={this.updateWaiver}
                updateWarranty={this.updateWarranty}
                updateQuantity={this.updateQuantity}
                removeItem={this.removeItem}
                onInputFocus={this.onInputFocus}
                onInputBlur={this.onInputBlur}
              />
            </CSSTransition>
          ))}
        </TransitionGroup>
      )
    } else {
      return <p className={cx('empty', 'items', styles['cart-items__error'])}>Your cart is empty</p>
    }
  }
}

Items.propTypes = {
  cartPlan: PropTypes.oneOfType([
    PropTypes.instanceOf(RentalPlan),
    PropTypes.instanceOf(SalePlan)
  ]).isRequired,
  updateCartPlan: PropTypes.func.isRequired,
  toggleLenscapModal: PropTypes.func.isRequired
}

export default Items
